export enum PageEvents {
  Login = 'log_in',
  CompleteSignup = 'complete_signup', // not used?
  Signup = 'onboarding_funnel_1_account_create_v1',
  OnboardingWelcome = 'onboarding_funnel_1_welcome_v2',
  OnboardingLifeAreas = 'onboarding_funnel_1_life_area_v2',
  OnboardingGoals = 'onboarding_funnel_1_create_goals_v2',
  OnboardingHabits = 'onboarding_funnel_1_create_habits_v2',
  OnboardingTasks = 'onboarding_funnel_1_create_tasks_v2',
  OnboardingWorkSituation = 'onboarding_funnel_1_work_situation_v2',
  OnboardingHearAbout = 'onboarding_funnel_1_hear_about_us_v2',
  OnboardingPremium = 'onboarding_funnel_1_premium_v2',
  Today = 'today',
  TodayCalendar = 'today_calendar',
  Inbox = 'inbox',
  Upcoming = 'upcoming',
  UpcomingWeek = 'upcoming_week',
  UpcomingFourDays = 'upcoming_4_days',
  UpcomingMonth = 'upcoming_month',
  AllTasks = 'allTasks',
  Habits = 'habits',
  LifeAreas = 'lifeAreas',
  LifeAreaDetailVision = 'life_area_detail_vision',
  LifeAreaDetailGoals = 'life_area_detail_goals',
  LifeAreaDetailTasks = 'life_area_detail_tasks',
  LifeAreaDetailAchievements = 'life_area_detail_achievements',
  GoalsList = 'goals-list',
  GoalsTimeline = 'goals-timeline',
  GoalsDetail = 'goalDetail',
  GoalEdit = 'goalWizard',
  GoalTemplatesOverview = 'goalTemplatePicker',
  GoalTemplatePreview = 'goalTemplatePreview',
  Journal = 'journal',
  TagDetail = 'tagDetail',
  SearchDialog = 'search_dialog',
  SearchResults = 'search_results',
  Completed = 'completed',
}
